import { Principal } from '../../shared/index';
import { AlertService } from 'ng-jhipster';
import { School, SchoolService } from '../school';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

export abstract class AbstractDialogComponent {

    public schools: School[];
    protected currentSchool: School;

    constructor(
        protected schoolService: SchoolService,
        protected alertService: AlertService,
        protected principal: Principal
    ) { }

    protected loadSchools() {
        this.principal.hasAnyAuthority(['ROLE_ADMIN']).then(isAdmin => {
            if (isAdmin) {
                this.schoolService.query().subscribe(
                    (res: HttpResponse<School[]>) => { this.schools = res.body; }, (res: HttpErrorResponse) => this.onError(res));
            }
        });
    }

    protected loadCurrentSchool() {
        this.schoolService.findCurrent().subscribe(
            (school: School) => this.currentSchool = school,
            (error: HttpErrorResponse) => this.onError(error)
        );
    }

    protected onError(error: HttpErrorResponse) {
        this.alertService.error(error.error.message, null, null);
    }

    protected enableOnlinePaymentsFields(): boolean {
        return this.currentSchool && this.currentSchool.acceptOnlinePayments && this.currentSchool.backofficeAccountId;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/abstract-dialog-component/abstract-dialog.component.ts